import { PlusCircleIcon, XCircleIcon } from '@heroicons/react/16/solid';
import PropTypes from 'prop-types';

const AppModulePill = ({ field, register, fieldIndex, onPreview }) => {
	if (field.value) {
		return (
			<div className="dropdown dropdown-hover">
				<label className="m-1 overflow-hidden text-xs font-bold border rounded-full swap border-primary text-primary">
					<input
						type="checkbox"
						{...register(`serviceForms.${fieldIndex}.value`)}
					/>
					<div className="flex flex-row px-2 py-1 text-white align-middle swap-on bg-primary">
						<span>{field.name}</span>
						<XCircleIcon className="inline-block w-3 h-4 ml-1" />
					</div>
					<div className="flex flex-row px-2 py-1 align-middle swap-off">
						<span>{field.name}</span>
						<PlusCircleIcon className="inline-block w-3 h-4 ml-1" />
					</div>
				</label>
				<ul
					tabIndex={0}
					className="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow"
				>
					<li>
						<a onClick={() => onPreview(field.id)}>Preview {field.name}</a>
					</li>
				</ul>
			</div>
		);
	}
	return null;
};

AppModulePill.propTypes = {
	field: PropTypes.object,
	register: PropTypes.func.isRequired,
	fieldIndex: PropTypes.number,
	onPreview: PropTypes.func.isRequired,
};

export default AppModulePill;
